// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.jsonplaceholder.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.jsonplaceholder.dto.CloudTodoDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "jsonplaceholder")
public class _JsonPlaceholderApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : JsonPlaceholderApi {
  override suspend fun getTodo(id: Int): CloudTodoDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "todos/${"$id".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CloudTodoDto>(),)!! 
  }

  override suspend fun updateTodo(id: Int, todo: CloudTodoDto): CloudTodoDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "todos/${"$id".encodeURLPath()}")
        }
        setBody(todo) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CloudTodoDto>(),)!! 
  }
}

public class _JsonPlaceholderApiProvider : ClassProvider<JsonPlaceholderApi> {
  override fun create(_ktorfit: Ktorfit): JsonPlaceholderApi = _JsonPlaceholderApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createJsonPlaceholderApi(): JsonPlaceholderApi = _JsonPlaceholderApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
